// removed by extract-text-webpack-plugin
module.exports = {"breadcrumb":"breadcrumb__3Mpwr"};


//////////////////
// WEBPACK FOOTER
// ./components/breadcrumb/style.css
// module id = FXz+
// module chunks = 8